var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"50px"},domProps:{"innerHTML":_vm._s(_vm.data.configuration.wb_html_code__long_text__)}})}
var staticRenderFns = []

export { render, staticRenderFns }